
//
export const ListOfPricesRange = [
    { id: 1, title: 'الي 800 الف' },
    { id: 2, title: 'من 800 الف الي مليون و 600 الف' },
    { id: 3, title: 'من مليون و 600 الف الي 2 مليون و 400 الف' },
    { id: 4, title: 'من 2 مليون و 400 الف الي 3 مليون و 200 الف' },
    { id: 5, title: 'من 3 مليون و 200 الف فاكثر' }
]